export default __webpack_public_path__ + "dist/assets/pin-map.png";